<template>
  <PageWrapper
    :isLoading="isLoading"
    has-filters
    @submitFilters="setPageNumberAndSendRequest"
  >
    <template #title> زبان آموز های کلاس ترمیک </template>
    <template #filters>
      <SearchInput
        class="filters-width w-24"
        inputId="fullName"
        inputLabel="جستجو بر اساس نام زبان آموز"
        inputPlaceholder="امیر..."
        v-model.trim="studentListFilters.fullName"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>
      <SearchInput
        class="filters-width w-24"
        inputId="mobile"
        inputLabel="جستجو بر اساس شماره زبان آموز"
        inputPlaceholder="0912..."
        v-model.trim="studentListFilters.mobile"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>
      <SearchInput
        class="filters-width w-24"
        inputId="email"
        inputLabel="جستجو بر اساس ایمیل زبان آموز"
        inputPlaceholder="example@ferman.org"
        v-model.trim="studentListFilters.email"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>
    </template>
    <CustomTable
      v-if="studentsList"
      :pageNumber="studentListFilters.pageNumber"
      :count="studentListFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="studentsList"
      @changePage="changePage"
    >
      <template #index="data">
        {{
          Math.ceil(
            data.index +
              1 +
              (studentListFilters.pageNumber - 1) * studentListFilters.count
          )
        }}
      </template>
      <template #userFullName="data">
        <b-link :to="`/users/${data.item.userId}`">
          {{ data.item.userFullName }}
        </b-link>
      </template>
      <template #isDiscounted="data">
        <BBadge
          class="font-weight-normal"
          :variant="data.item.isDiscounted ? 'success' : 'danger'"
        >
          {{ data.item.isDiscounted ? "بله" : "خیر" }}
        </BBadge>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    termicCourseId: {
      type: [String, Number],
    },
  },
  mounted() {
    if (this.computedPageRouteQuery) {
      this.studentListFilters.pageNumber = this.computedPageRouteQuery;
    } else {
      this.studentListFilters.pageNumber = 1;
    }
    this.getAllStudentsForTermicCourse();
  },
  data() {
    return {
      isLoading: false,
      studentsList: null,
      totalCount: null,
      studentListFilters: {
        pageNumber: 1,
        count: 10,
        termicCourseId: null,
        hasDiscounted: null,
        mobile: null,
        fullName: null,
        email: null,
      },
      tableColumns: [
        {
          key: "index",
          label: "ردیف",
        },

        {
          key: "userFullName",
          label: "نام کاربر",
        },

        {
          key: "userPhoneNumber",
          label: "شماره همراه کاربر",
        },

        {
          key: "isDiscounted",
          label: "پرداخت با تخفیف",
        },

        {
          key: "payedAmount",
          label: "مبلغ پرداختی",
          formatter: (val) => `${Intl.NumberFormat("en-US").format(val)} تومان`,
        },

        {
          key: "signUpDate",
          label: "تاریخ ثبت نام",
          formatter: (val) => this.customFullDateTimeConvert(val),
        },
      ],
    };
  },

  methods: {
    async getAllStudentsForTermicCourse() {
      try {
        this.isLoading = true;
        this.studentListFilters.termicCourseId = this.termicCourseId;
        const _this = this;
        const getSignedUpStudentsForTermicCourse =
          new GetSignedUpStudentsForTermicCourse(_this);
        getSignedUpStudentsForTermicCourse.setRequestParam(
          _this.studentListFilters
        );
        await getSignedUpStudentsForTermicCourse.fetch((res) => {
          _this.studentsList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          studentsListPage: pageNumber,
        },
      });
    },
    setPageNumberAndSendRequest() {
      this.studentListFilters.pageNumber = 1;
      this.setPageNumberQuery(1);
      this.getAllStudentsForTermicCourse();
    },
    changePage(pageNumber) {
      this.studentListFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      this.getAllStudentsForTermicCourse();
    },
  },
  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.studentsListPage) {
        return this.$route.query.studentsListPage;
      }
      return null;
    },
  },
  mixins: [timeConvertUtils],
  components: {
    PageWrapper,
    SearchInput,
    CustomTable,
    BBadge,
    BLink,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BBadge, BLink } from "bootstrap-vue";
import { GetSignedUpStudentsForTermicCourse } from "@/libs/Api/TermicCourses";
</script>
